// import http from "./http";

// export const loginUser = async (email, password) => {
//   const res = await http.post("admin_login", { email, password });

//   if (res.data.status === "success") {
//     // Save login data
//     localStorage.setItem("token", res.data.data.token ?? "");
//     localStorage.setItem("user", JSON.stringify(res.data.data));
//   }

//   return res.data;
// };


// src/services/authService.jsx
import http from "./http";

// Login (admin_login) — returns server response
export const loginUser = async (email, password) => {
  const res = await http.post("school_login", { email, password });

  // Server returns { status, message, data: { token, id, name, email, ... } }
  if (res.data?.status === "success") {
    const userData = res.data.data || {};
    // Save both for compatibility
    if (userData.token) {
      localStorage.setItem("token", userData.token);
    }
    localStorage.setItem("user", JSON.stringify(userData));
  }

  return res.data;
};

// Logout convenience
export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  window.location.href = "/sign-in";
};

// Register School (WORKING - FORM DATA)
export const registerSchool = async (data) => {
  try {
    const formData = new FormData();

    // ✅ same fields as Postman
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("phone", data.phone);
    formData.append("address", data.address);
    formData.append("reference_by", data.reference_by);

    // ✅ logo file (IMPORTANT)
    if (data.logo && data.logo instanceof File) {
      formData.append("logo", data.logo);
    }

    const res = await http.post("school_register", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;

  } catch (error) {
    console.error("Register Error:", error);

    if (error.response) {
      throw new Error(error.response.data?.message || "Server error");
    } else {
      throw new Error("Network error");
    }
  }
};

// src/services/authService.jsx

// Step 1: Request the OTP
export const requestOtp = async (email) => {
  const response = await http.post("forgot_password", {
    action: "send_otp",
    email
  });
  return response.data;
};

// Step 2: Reset with OTP
export const resetPassword = async (payload) => {
  const response = await http.post("forgot_password", {
    action: "reset_password",
    email: payload.email,
    otp: payload.otp,
    new_password: payload.new_password
  });
  return response.data;
};
// src/services/authService.jsx

// src/services/authService.jsx

